import { getRuntimeEnvironmentVariable as env } from "./getRuntimeEnvironmentVariable";

export function getFullClientRuntimeConfig() {
  return {
    NPS_REDIRECT_URL: env("NPS_REDIRECT_URL", "NEXT_PUBLIC_NPS_REDIRECT_URL"),
    NPS_FIXAUTO_REDIRECT_URL: env(
      "NPS_FIXAUTO_REDIRECT_URL",
      "NEXT_PUBLIC_NPS_FIXAUTO_REDIRECT_URL"
    ),
    NPS_CRE_REDIRECT_URL: env(
      "NPS_CRE_REDIRECT_URL",
      "NEXT_PUBLIC_NPS_CRE_REDIRECT_URL"
    ),
    V7_REDIRECT_URL: env("V7_REDIRECT_URL", "NEXT_PUBLIC_V7_REDIRECT_URL"),
    V7_PROC_REDIRECT_URL: env(
      "V7_PROC_REDIRECT_URL",
      "NEXT_PUBLIC_V7_PROC_REDIRECT_URL"
    ),
    V7_CRE_REDIRECT_URL: env(
      "V7_CRE_REDIRECT_URL",
      "NEXT_PUBLIC_V7_CRE_REDIRECT_URL"
    ),
    SPEEDYAUTO_REDIRECT_URL: env(
      "SPEEDYAUTO_REDIRECT_URL",
      "NEXT_PUBLIC_SPEEDYAUTO_REDIRECT_URL"
    ),
    NOVUSGLASS_REDIRECT_URL: env(
      "NOVUSGLASS_REDIRECT_URL",
      "NEXT_PUBLIC_NOVUSGLASS_REDIRECT_URL"
    ),
    FIXAUTO_REDIRECT_URL: env(
      "FIXAUTO_REDIRECT_URL",
      "NEXT_PUBLIC_FIXAUTO_REDIRECT_URL"
    ),
    SUPPORT_EMAIL: env("SUPPORT_EMAIL", "NEXT_PUBLIC_SUPPORT_EMAIL"),
    GOOGLE_EMBED_API_KEY: env(
      "GOOGLE_EMBED_API_KEY",
      "NEXT_PUBLIC_GOOGLE_EMBED_API_KEY"
    ),
    API_URL: env("API_URL", "NEXT_PUBLIC_API_URL"),
    IDS_URL: env("IDS_URL", "NEXT_PUBLIC_IDS_URL"),
    CENTRIX_URL: env("CENTRIX_URL", "NEXT_PUBLIC_CENTRIX_URL"),
    APPLICATIONINSIGHTS_CONNECTION_STRING: env(
      "APPLICATIONINSIGHTS_CONNECTION_STRING"
    ),
    REVALIDATE_IF_STALE: env("REVALIDATE_IF_STALE"),
    SANITIZE_CMS_CONTENT: env("SANITIZE_CMS_CONTENT"),
    COMMUNITY_IDEA_HREF: env("COMMUNITY_IDEA_HREF"),
    COMMUNITY_IDEA_TARGET: env("COMMUNITY_IDEA_TARGET"),
    COMMUNITY_ISSUE_HREF: env("COMMUNITY_ISSUE_HREF"),
    COMMUNITY_ISSUE_TARGET: env("COMMUNITY_ISSUE_TARGET"),
    COMMUNITY_RELEASE_NOTES_HREF: env("COMMUNITY_RELEASE_NOTES_HREF"),
    COMMUNITY_RELEASE_NOTES_TARGET: env("COMMUNITY_RELEASE_NOTES_TARGET"),
    NEXT_PUBLIC_MUI_X_LICENSE: env("NEXT_PUBLIC_MUI_X_LICENSE"),
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: env("NEXT_PUBLIC_RECAPTCHA_SITE_KEY"),
    NEXT_PUBLIC_DEFAULT_DEV_BRAND_CODE: env(
      "NEXT_PUBLIC_DEFAULT_DEV_BRAND_CODE"
    ),
    NEXT_PUBLIC_AUTHORIZE_DOTNET_CLIENT_KEY: env(
      "NEXT_PUBLIC_AUTHORIZE_DOTNET_CLIENT_KEY"
    ),
    NEXT_PUBLIC_AUTHORIZE_DOTNET_API_LOGIN_ID: env(
      "NEXT_PUBLIC_AUTHORIZE_DOTNET_API_LOGIN_ID"
    ),
    NEXT_PUBLIC_AUTHORIZE_DOTNET_ENVIRONMENT: env(
      "NEXT_PUBLIC_AUTHORIZE_DOTNET_ENVIRONMENT"
    ),
    NEXT_ROYALTY_PAYMENT_SHOW_LOCATION: env(
      "NEXT_ROYALTY_PAYMENT_SHOW_LOCATION",
      "NEXT_PUBLIC_ROYALTY_PAYMENT_SHOW_LOCATION"
    ),
    NEXT_PUBLIC_ROYALTY_PAYMENT_ENABLED: env(
      "NEXT_PUBLIC_ROYALTY_PAYMENT_ENABLED"
    ),
    NEXT_PUBLIC_HTML_EDITOR_IMAGE_UPLOAD_ENABLED: env(
      "NEXT_PUBLIC_HTML_EDITOR_IMAGE_UPLOAD_ENABLED"
    ),
    NEXT_PUBLIC_MSAL_AUTHORITY: env("NEXT_PUBLIC_MSAL_AUTHORITY"),
    NEXT_PUBLIC_MSAL_CLIENT_ID: env("NEXT_PUBLIC_MSAL_CLIENT_ID"),
    NEXT_PUBLIC_MSAL_REDIRECT_URI: env("NEXT_PUBLIC_MSAL_REDIRECT_URI"),
    NEXT_PUBLIC_SHAREPOINT_URL: env("NEXT_PUBLIC_SHAREPOINT_URL"),
    NEXT_PUBLIC_DEFAULT_NEWS_TYPE_ID: env("NEXT_PUBLIC_DEFAULT_NEWS_TYPE_ID"),
    NEXT_PUBLIC_DEFAULT_NEWS_CATEGORY_ID: env(
      "NEXT_PUBLIC_DEFAULT_NEWS_CATEGORY_ID"
    ),
    NEXT_PUBLIC_DEFAULT_EVENT_TYPE_ID: env("NEXT_PUBLIC_DEFAULT_EVENT_TYPE_ID"),
    NEXT_PUBLIC_DEFAULT_EVENT_CATEGORY_ID: env(
      "NEXT_PUBLIC_DEFAULT_EVENT_CATEGORY_ID"
    ),
    NEXT_PUBLIC_LOGO_BASE_URL: env("NEXT_PUBLIC_LOGO_BASE_URL"),
    NEXT_PUBLIC_FINANCE_DOWNLOAD_EXCLUDE_PREFIXES: env(
      "NEXT_PUBLIC_FINANCE_DOWNLOAD_EXCLUDE_PREFIXES"
    ),
  };
}

export type FullClientRuntimeConfig = ReturnType<
  typeof getFullClientRuntimeConfig
>;

export function getPublicClientRuntimeConfig() {
  return {
    API_URL: env("API_URL", "NEXT_PUBLIC_API_URL"),
    APPLICATIONINSIGHTS_CONNECTION_STRING: env(
      "APPLICATIONINSIGHTS_CONNECTION_STRING"
    ),
    SUPPORT_EMAIL: env("SUPPORT_EMAIL", "NEXT_PUBLIC_SUPPORT_EMAIL"),
    NEXT_PUBLIC_LOGO_BASE_URL: env("NEXT_PUBLIC_LOGO_BASE_URL"),
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: env("NEXT_PUBLIC_RECAPTCHA_SITE_KEY"),
  };
}
